import React from 'react';
import { Skeleton, Stack } from '@mui/material';

export const PageFallback = () => {
  return (
    <Stack gap="1rem">
      <Skeleton sx={{ height: '150px' }} variant="rectangular" />
      <Skeleton sx={{ height: '150px' }} variant="rectangular" />
      <Skeleton sx={{ height: '150px' }} variant="rectangular" />
    </Stack>
  );
};
